import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useState } from "react";

export default function Navbar() {
  const { user, userRole, logout } = useAuth();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLoginDropdownOpen, setIsLoginDropdownOpen] = useState(false);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const getBreadcrumbs = () => {
    const path = location.pathname;
    const crumbs = [];

    if (userRole === 'teacher') {
      if (path === '/dashboard') {
        crumbs.push({ name: 'Dashboard', path: '/dashboard' });
      } else if (path === '/teacher/ai-builder') {
        crumbs.push({ name: 'Dashboard', path: '/dashboard' });
        crumbs.push({ name: 'AI Exam Builder', path: '/teacher/ai-builder' });
      } else if (path === '/teacher/quiz-library') {
        crumbs.push({ name: 'Dashboard', path: '/dashboard' });
        crumbs.push({ name: 'My Quizzes', path: '/teacher/quiz-library' });
      } else if (path === '/teacher/assignments') {
        crumbs.push({ name: 'Dashboard', path: '/dashboard' });
        crumbs.push({ name: 'Active Assignments', path: '/teacher/assignments' });
      } else if (path === '/student-manager') {
        crumbs.push({ name: 'Dashboard', path: '/dashboard' });
        crumbs.push({ name: 'Student Manager', path: '/student-manager' });
      } else if (path === '/teacher/classes') {
        crumbs.push({ name: 'Dashboard', path: '/dashboard' });
        crumbs.push({ name: 'Classes', path: '/teacher/classes' });
      }
      // Lessons commented out for MVP Phase 1
      // } else if (path === '/lessons') {
      //   crumbs.push({ name: 'Dashboard', path: '/dashboard' });
      //   crumbs.push({ name: 'IGCSE Lessons', path: '/lessons' });
      // } else if (path.startsWith('/lessons/')) {
      //   crumbs.push({ name: 'Dashboard', path: '/dashboard' });
      //   crumbs.push({ name: 'IGCSE Lessons', path: '/lessons' });
      //   crumbs.push({ name: 'Lesson Viewer', path: path });
      // }
    } else if (userRole === 'student') {
      if (path === '/student-dashboard') {
        crumbs.push({ name: 'Dashboard', path: '/student-dashboard' });
      }
    } else if (userRole === 'masterAdmin') {
      if (path === '/master-admin') {
        crumbs.push({ name: 'Master Admin', path: '/master-admin' });
      }
    }

    return crumbs;
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  const breadcrumbs = getBreadcrumbs();

  return (
    <nav className="bg-white dark:bg-gray-800 shadow-lg border-b border-gray-200 dark:border-gray-700">
      {/* Main Navigation Bar */}
      <div className="px-4 py-3">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="text-xl sm:text-2xl font-bold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300" onClick={closeMobileMenu}>
            🔒 ExamLock
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-6">
            {/* Role-based Navigation Menu */}
            {user && userRole === "teacher" && (
              <div className="flex space-x-4">
                <Link
                  to="/dashboard"
                  className={`px-3 py-2 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/dashboard'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  📊 Dashboard
                </Link>
                <Link
                  to="/teacher/ai-builder"
                  className={`px-3 py-2 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/teacher/ai-builder'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  🤖 AI Builder
                </Link>
                <Link
                  to="/teacher/quiz-library"
                  className={`px-3 py-2 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/teacher/quiz-library'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  📚 My Quizzes
                </Link>
                {/* Lessons hidden for MVP Phase 1 */}
                {/* <Link
                  to="/lessons"
                  className={`px-3 py-2 rounded-lg font-medium transition duration-200 ${
                    location.pathname.startsWith('/lessons')
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  📖 Lessons
                </Link> */}
                <Link
                  to="/teacher/assignments"
                  className={`px-3 py-2 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/teacher/assignments'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  📊 Active Assignments
                </Link>
                <Link
                  to="/student-manager"
                  className={`px-3 py-2 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/student-manager'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  👥 Students
                </Link>
                <Link
                  to="/teacher/classes"
                  className={`px-3 py-2 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/teacher/classes'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  📚 Classes
                </Link>
              </div>
            )}

            {user && userRole === "student" && (
              <div className="flex space-x-4">
                <Link
                  to="/student-dashboard"
                  className={`px-3 py-2 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/student-dashboard'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  📊 Dashboard
                </Link>
              </div>
            )}

            {user && userRole === "masterAdmin" && (
              <div className="flex space-x-4">
                <Link
                  to="/master-admin"
                  className={`px-3 py-2 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/master-admin'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                >
                  🔥 Master Admin
                </Link>
              </div>
            )}

            {/* Professional Navigation for Public Users */}
            {!user && (
              <div className="flex space-x-6 text-sm">
                <Link to="/features" className="text-gray-700 hover:text-blue-600 font-medium transition duration-200">
                  Features
                </Link>
                <Link to="/pricing" className="text-gray-700 hover:text-blue-600 font-medium transition duration-200">
                  Pricing
                </Link>
                <Link to="/about" className="text-gray-700 hover:text-blue-600 font-medium transition duration-200">
                  About
                </Link>
                <Link to="/faq" className="text-gray-700 hover:text-blue-600 font-medium transition duration-200">
                  FAQ
                </Link>
                <Link to="/contact" className="text-gray-700 hover:text-blue-600 font-medium transition duration-200">
                  Contact
                </Link>
              </div>
            )}

            {/* Desktop User Menu */}
            <div className="flex items-center space-x-4">
              {!user && (
                <>
                  <Link
                    to="/login"
                    className="px-4 py-2 text-blue-600 hover:text-blue-700 font-medium"
                  >
                    Login
                  </Link>
                  <Link
                    to="/teacher-register"
                    className="px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg font-medium transition duration-200"
                  >
                    Start Free
                  </Link>
                </>
              )}

              {user && (
                <>
                  <div className="text-sm text-gray-600 hidden xl:block">
                    {userRole === 'teacher' && '👩‍🏫'}
                    {userRole === 'student' && '👨‍🎓'}
                    {userRole === 'masterAdmin' && '🔥'}
                    {user.email}
                  </div>
                  <button
                    onClick={handleLogout}
                    className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition duration-200"
                  >
                    Logout
                  </button>
                </>
              )}
            </div>
          </div>

          {/* Mobile Menu Button */}
          <div className="lg:hidden flex items-center space-x-3">
            {user && (
              <div className="text-xs text-gray-600">
                {userRole === 'teacher' && '👩‍🏫'}
                {userRole === 'student' && '👨‍🎓'}
                {userRole === 'masterAdmin' && '🔥'}
              </div>
            )}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="p-2 rounded-lg text-gray-600 hover:text-blue-600 hover:bg-gray-100 transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500"
              aria-label="Toggle mobile menu"
            >
              <div className="w-6 h-6 flex flex-col justify-center items-center">
                <div className={`w-5 h-0.5 bg-current transition-all duration-200 ${
                  isMobileMenuOpen ? 'rotate-45 translate-y-0.5' : ''
                }`}></div>
                <div className={`w-5 h-0.5 bg-current mt-1 transition-all duration-200 ${
                  isMobileMenuOpen ? 'opacity-0' : ''
                }`}></div>
                <div className={`w-5 h-0.5 bg-current mt-1 transition-all duration-200 ${
                  isMobileMenuOpen ? '-rotate-45 -translate-y-1.5' : ''
                }`}></div>
              </div>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="lg:hidden mt-4 pb-4 border-t border-gray-200">
            <div className="pt-4 space-y-3">
              {/* Authenticated User Mobile Menu */}
              {user && userRole === "teacher" && (
                <>
                  <Link
                    to="/dashboard"
                    className={`block px-4 py-3 rounded-lg font-medium transition duration-200 ${
                      location.pathname === '/dashboard'
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={closeMobileMenu}
                  >
                    📊 Dashboard
                  </Link>
                  <Link
                    to="/teacher/ai-builder"
                    className={`block px-4 py-3 rounded-lg font-medium transition duration-200 ${
                      location.pathname === '/teacher/ai-builder'
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={closeMobileMenu}
                  >
                    🤖 AI Exam Builder
                  </Link>
                  <Link
                    to="/teacher/quiz-library"
                    className={`block px-4 py-3 rounded-lg font-medium transition duration-200 ${
                      location.pathname === '/teacher/quiz-library'
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={closeMobileMenu}
                  >
                    📚 My Quizzes
                  </Link>
                  {/* Lessons hidden for MVP Phase 1 */}
                  {/* <Link
                    to="/lessons"
                    className={`block px-4 py-3 rounded-lg font-medium transition duration-200 ${
                      location.pathname.startsWith('/lessons')
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={closeMobileMenu}
                  >
                    📖 IGCSE Lessons
                  </Link> */}
                  <Link
                    to="/teacher/assignments"
                    className={`block px-4 py-3 rounded-lg font-medium transition duration-200 ${
                      location.pathname === '/teacher/assignments'
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={closeMobileMenu}
                  >
                    📊 Assignment Manager
                  </Link>
                  <Link
                    to="/student-manager"
                    className={`block px-4 py-3 rounded-lg font-medium transition duration-200 ${
                      location.pathname === '/student-manager'
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={closeMobileMenu}
                  >
                    👥 Student Manager
                  </Link>
                  <Link
                    to="/teacher/classes"
                    className={`block px-4 py-3 rounded-lg font-medium transition duration-200 ${
                      location.pathname === '/teacher/classes'
                        ? 'bg-blue-100 text-blue-700'
                        : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                    }`}
                    onClick={closeMobileMenu}
                  >
                    📚 Classes
                  </Link>
                </>
              )}

              {user && userRole === "student" && (
                <Link
                  to="/student-dashboard"
                  className={`block px-4 py-3 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/student-dashboard'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                  onClick={closeMobileMenu}
                >
                  📊 Dashboard
                </Link>
              )}

              {user && userRole === "masterAdmin" && (
                <Link
                  to="/master-admin"
                  className={`block px-4 py-3 rounded-lg font-medium transition duration-200 ${
                    location.pathname === '/master-admin'
                      ? 'bg-blue-100 text-blue-700'
                      : 'text-gray-600 dark:text-gray-300 hover:text-blue-600 dark:hover:text-blue-400 hover:bg-gray-100 dark:hover:bg-gray-700'
                  }`}
                  onClick={closeMobileMenu}
                >
                  🔥 Master Admin
                </Link>
              )}

              {/* Public Mobile Menu */}
              {!user && (
                <>
                  <Link
                    to="/features"
                    className="block px-4 py-3 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-gray-100 font-medium transition duration-200"
                    onClick={closeMobileMenu}
                  >
                    Features
                  </Link>
                  <Link
                    to="/pricing"
                    className="block px-4 py-3 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-gray-100 font-medium transition duration-200"
                    onClick={closeMobileMenu}
                  >
                    Pricing
                  </Link>
                  <Link
                    to="/about"
                    className="block px-4 py-3 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-gray-100 font-medium transition duration-200"
                    onClick={closeMobileMenu}
                  >
                    About
                  </Link>
                  <Link
                    to="/faq"
                    className="block px-4 py-3 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-gray-100 font-medium transition duration-200"
                    onClick={closeMobileMenu}
                  >
                    FAQ
                  </Link>
                  <Link
                    to="/contact"
                    className="block px-4 py-3 rounded-lg text-gray-700 hover:text-blue-600 hover:bg-gray-100 font-medium transition duration-200"
                    onClick={closeMobileMenu}
                  >
                    Contact
                  </Link>
                  <div className="border-t border-gray-200 pt-3 mt-3">
                    <Link
                      to="/login"
                      className="block px-4 py-3 text-blue-600 hover:text-blue-700 font-medium"
                      onClick={closeMobileMenu}
                    >
                      Login
                    </Link>
                    <Link
                      to="/teacher-register"
                      className="block mt-2 mx-4 py-3 bg-green-600 hover:bg-green-700 text-white text-center rounded-lg font-medium transition duration-200"
                      onClick={closeMobileMenu}
                    >
                      Start Free
                    </Link>
                  </div>
                </>
              )}

              {/* Mobile User Actions */}
              {user && (
                <div className="border-t border-gray-200 pt-3 mt-3">
                  <div className="px-4 py-2 text-sm text-gray-600">
                    {user.email}
                  </div>
                  <button
                    onClick={() => {
                      handleLogout();
                      closeMobileMenu();
                    }}
                    className="w-full mt-2 mx-4 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-medium transition duration-200"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        )}
      </div>

      {/* Breadcrumbs */}
      {breadcrumbs.length > 0 && (
        <div className="px-4 py-2 bg-gray-50 dark:bg-gray-700 border-t border-gray-200 dark:border-gray-600">
          <nav className="flex text-sm text-gray-600 dark:text-gray-300">
            <Link to="/" className="hover:text-blue-600">Home</Link>
            {breadcrumbs.map((crumb, index) => (
              <div key={index} className="flex items-center">
                <span className="mx-2">›</span>
                {index === breadcrumbs.length - 1 ? (
                  <span className="text-gray-800 font-medium">{crumb.name}</span>
                ) : (
                  <Link to={crumb.path} className="hover:text-blue-600">{crumb.name}</Link>
                )}
              </div>
            ))}
          </nav>
        </div>
      )}
    </nav>
  );
}